<template>
  <div :class="{isShow:!isShowDanMu}" class="play-back-barrages">
    <v-barrage :initDanmu='initDanmu' :isPause="isPause" :arr='arr' :percent="100">
    </v-barrage>
  </div>
</template>

<script>
import VBarrage from "@/views/cloudClassCenter/components/common/VBarrage";
import { selectBulletScreenNote } from "@/network/cloudRequest/api";

export default {
  name: "PlayBackBarrages",
  components: {
    VBarrage
  },
  props: {
    isDanMuPause: {},
    liveBarrage: {},
    //视频当前播放时间
    playTimeupDate: {},
    //是否显示弹幕
    isShowDanMu: {},
    //初始化弹幕
    initDanmu: {}
  },
  data() {
    return {
      //弹幕库
      arr: [],
      isPause: false,
      sendContent: null,
      isJs: false,
      direction: "default",
      //视频保存弹幕
      danmuku: [],
      //弹幕添加延迟函数
      addDanmuTO: null,
      //延迟函数ID数组
      setTimeoutId: [],
      //视频播放时间
      videoPlayTime: 0
    };
  },

  created() {
    let data = {
      cloudClassId: this.$route.query.cloudClassId
    };

    selectBulletScreenNote(data).then(res => {
      if (res.data.success) {
        this.danmuku = res.data.data;
        this.addDanmu(this.videoPlayTime, res.data.data);
      }
    });
  },

  methods: {
    //延时添加弹幕
    addDanmu(time, data) {
      data.forEach(item => {
        //弹幕发送时间  相对于播放进度
        if (item.timeTemp - time > 0) {
          let timeoutId = setTimeout(() => {
            this.arr.push({
              content: item.say, // 弹幕内容
              direction: this.direction, // 方向  default | top
              isSelf: false, // 是否是自己发的弹幕
              style: {
                color: "white" // 弹幕颜色`
              },
              isJs: false // 是否解析html
            });
            let index = "";
            this.setTimeoutId.forEach((val, i) => {
              if (val == timeoutId) {
                index = i;
              }
            });
            this.setTimeoutId.splice(index, 1);
          }, item.createTime - time);
          this.setTimeoutId.push(timeoutId);
        }
      });
    },

    //清除添加弹幕的延迟函数
    clearDanmu() {
      this.setTimeoutId.forEach(item => {
        clearTimeout(item);
      });
    }
  },

  watch: {
    liveBarrage(newVal) {
      this.arr.push({
        content: newVal.say, // 弹幕内容
        direction: this.direction, // 方向  default | top
        isSelf: newVal.fromId == this.$store.state.userId ? true : false, // 是否是自己发的弹幕
        // style: {
        //   color: "red" // 弹幕颜色
        // },
        isJs: false // 是否解析html
      });
    },

    isDanMuPause(newVal) {
      if (newVal) {
        this.isPause = true;
        this.clearDanmu();
      }
      if (!newVal) {
        this.addDanmu(this.videoPlayTime, this.danmuku);
        this.isPause = false;
      }
    },

    playTimeupDate(newVal) {
      if (newVal) {
        this.videoPlayTime = newVal;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.play-back-barrages {
  pointer-events: none;
  position: relative;
  width: 100%;
  height: 230px;
}

.isShow {
  opacity: 0;
}
</style>